<template>
  <RPopupEdit
    :value="item.editable.value"
    :title="item.editable.title"
    @ok="update({ ...$event, field: item.editable.field })"
  >
    <template v-slot="props">
      <RDropdown
        v-if="item.editable.type === 'select'"
        v-model="props.model.value"
        :disable="props.loading"
        :options="item.editable.options"
        option-value="id"
        option-label="name"
        map-options
        emit-value
        no-label
        no-hint
        no-options-sort
        style="width: 150px"
      />

      <RInput
        v-if="item.editable.type === 'text'"
        v-model="props.model.value"
        :disable="props.loading"
        no-feedback-icon
        no-hint
        no-label
        autofocus
        on-clear="focus"
        @keyup.enter.stop="update({ ...props, field: item.editable.field })"
      />
    </template>
  </RPopupEdit>
</template>

<script>
// Libraries
// Components
import RPopupEdit from '@/ui/RPopupEdit'

export default {
  components: {
    RPopupEdit
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  methods: {
    update(data) {
      this.$emit('update', data)
    }
  }
}
</script>
